import React, { useState } from 'react';
import firebase from 'firebase/compat/app';
import { Button, Typography, Space } from 'antd';

const { Title, Text } = Typography;
export function LoginPage() {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const signIn = async () => {
        setError(null);
        setLoading(true);
        try {
            const googleProvider = new firebase.auth.GoogleAuthProvider();
            googleProvider.setCustomParameters({ hd: 'designwithfriends.com' });
            await firebase.auth().signInWithPopup(googleProvider);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#0e1117',
            gap: 24,
        }}>
            <Title level={2} style={{ color: 'rgba(255,255,255,0.88)', margin: 0 }}>
                Admin Central
            </Title>
            <Button
                type="primary"
                size="large"
                loading={loading}
                onClick={signIn}
                style={{ minWidth: 220 }}
            >
                Sign in with Google
            </Button>
            {error && (
                <Text style={{ color: '#ff4d4f' }}>{error}</Text>
            )}
        </div>
    );
}
